import styled from "styled-components";

export const SearchAdd = styled.div`
    padding: .688rem 2rem;
    border-right: 1px solid #eff1f4;
    .form-control {
        color: #505f79;
        max-width: 12rem;
        font-size: 0.875rem;
    }
    .input-group>.form-control:not(:last-child) {
        border-radius: 0.25rem;
    }
    .input-group-text {
        background: none;
        border: 0;
    }
`;
export const MediaHeader = styled.h5`
    color: #505f79;
    margin-top: 0;
    margin-bottom: 0;
    font-weight: 600;
    font-size: 1rem;
`;
export const MediaSubHeader = styled.div`
    color: #97a0af;
    font-size: .875rem;
`;
export const MediaLabel = styled.span`

`;
export const ContentPanel = styled.div`

`;

export const ListWrapper = styled.div`
    
`;

export const ProductList = styled.div`
    font-size: 14px;
    color: #97a0af;
    word-break: break-word;
`;